export default __webpack_public_path__ + "static/10_Constellations-81bc981adb8c36346892edf5d49192ad.pdf";